import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getStoredData } from "../../api/fetchData";
import EditFormComponent from "../../components/EditFormComponent/EditFormComponent";
import "./AllEditPage.css";

const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc ? acc[key] : ""), obj);

const AllEditPage = () => {
  const { model, id } = useParams();
  const [formData, setFormData] = useState({});
  const [fieldConfig, setFieldConfig] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfigAndData = async () => {
      try {
        const stored = await getStoredData();
        const allConfigs = stored["1"]?.tableConfigs || {};
        const modelConfig = allConfigs[model];

        if (!modelConfig) return;

        setConfig(modelConfig);
        setFieldConfig(modelConfig.columns);

        const res = await axios.get(`${modelConfig.api}/${id}`);
        setFormData(res.data);

        const dropdowns = {};
        await Promise.all(
          modelConfig.columns.map(async (col) => {
            if (col.api) {
              const res = await axios.get(col.api);
              dropdowns[col.field] = res.data;
            }
          })
        );
        setDropdownOptions(dropdowns);
      } catch (err) {
        console.error("Failed to load data/config", err);
      }
    };

    fetchConfigAndData();
  }, [model, id]);

function setByPath(obj, path, value) {
  const keys = path.split(".");
  const newObj = { ...obj };
  let curr = newObj;

  keys.forEach((k, i) => {
    if (i === keys.length - 1) {
      curr[k] = value;
    } else {
      // if parent missing, create it
      if (curr[k] == null || typeof curr[k] !== "object") {
        curr[k] = {};
      } else {
        curr[k] = { ...curr[k] }; // clone to keep immutability
      }
      curr = curr[k];
    }
  });

  return newObj;
}



  const handleChange = (field, value) => {
    setFormData((prev) => setByPath(prev, field, value));
  };


  if (!config)
    return <div style={{ padding: 20 }}>Missing config for "{model}"</div>;


  return (
    <div className="edit-form-container" style={{ padding: 30 }}>
      {/* <h2 className="EditPageTitle">{config.title} - Edit</h2> */}
      <EditFormComponent
        fields={fieldConfig}
        formData={formData}
        dropdownOptions={dropdownOptions}
        onChange={handleChange}
        modelId={id}
        Put={config.api}
        file={config.uploadApi}
        model={model}
      />
    </div>
  );
};

export default AllEditPage;
